/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import Button from "./com/button";
import { passwordPattern } from "./utils";

const SignupPg = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [submitText, setSubmitText] = useState("Login");
  const { handleSubmit, register, errors } = useForm();
  const { c, m } = useParams();

  const setButtonText = (txt, cb = () => {}, wait = 4) => {
    setIsLoading(false);
    setSubmitText(txt);
    setTimeout(() => {
      setSubmitText("Login");
      cb();
    }, wait * 1000);
  };

  const onSignup = async (obj) => {
    if (!navigator.onLine) return setButtonText("Please check your Internet connection") && false;
    try {
      setIsLoading(true);
      const parms = {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
        method: "PUT",
      };
      const r = await fetch(
        "/patientmanagement/rest/users/activate?email=" + m + "&activationCode=" + c,
        parms
      );
      if (r.ok)
        return setButtonText("Activation Success! Proceed to Login...", () => history.push("/auth/login"));
      const j = await r.json();
      setButtonText(j.errors[0].msg);
    } catch (error) {
      setButtonText("Connectivity problem. Please try again later.");
    }
  };

  return (
    <div className="page">
      <div className="geneva-logo" style={{ transform: "scale(0.6)" }} />
      <div className="root">
        <form onSubmit={handleSubmit(onSignup)} className="tl-form">
          <div className="area">
            <h1>Activation</h1>
            <input
              className="tl-inp"
              disabled={isLoading}
              type="text"
              placeholder="Enter email or username..."
              name="username"
              ref={register({
                required: "Email or username is required",
                pattern: {
                  value: /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|[A-Z0-9]{5,})$/i,
                  message: "Invalid email address or username",
                },
              })}
            />
            <span className="err">{errors.username && errors.username.message}</span>
            <input
              className="tl-inp"
              type="password"
              disabled={isLoading}
              placeholder="Enter password..."
              name="password"
              ref={register({
                required: "Password is required",
                pattern: passwordPattern,
              })}
            />
            <span className="err">{errors.password && errors.password.message}</span>
          </div>
          <Button className="btn tl-btn" type="submit" isLoading={isLoading}>
            {" "}
            &nbsp; {submitText}{" "}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default SignupPg;
